import seedJson from "./seed.json";
import type { CurrencyCode, CurrencyInfo, LoginRecord, Scenario, SeedData } from "./types";

/** Canonical seed dataset — company, fiscal year, months and the 12 budget categories. */
export const SEED: SeedData = seedJson as SeedData;

export const MONTHS: string[] = SEED.months;

/** "Current" reporting month used throughout the demo dataset (Jul 2026 = index 3). */
export const CUR_MONTH_IDX = 3;

export const CURRENCIES: Record<CurrencyCode, CurrencyInfo> = {
  USD: { symbol: "$", rate: 1, locale: "en-US" },
  INR: { symbol: "₹", rate: 94, locale: "en-IN" },
  EUR: { symbol: "€", rate: 0.92, locale: "de-DE" },
  AED: { symbol: "د.إ", rate: 3.673, locale: "en-AE" },
  SAR: { symbol: "﷼", rate: 3.75, locale: "en-SA" },
};

export const SCENARIOS: Record<Scenario, number> = {
  Approved: 1,
  "Revised Budget": 1.05,
  Forecast: 1.0,
};

/** Category letter -> owning department, used to group Budget by Department. */
export const DEPT: Record<string, string> = {
  A: "Human Resources",
  B: "Facilities",
  C: "IT",
  D: "Human Resources",
  E: "Engineering",
  F: "Finance",
  G: "Regulatory",
  H: "Sales & Marketing",
  I: "Operations",
  J: "Facilities",
  K: "Operations",
  L: "Manufacturing",
};

export const NARR: string[] = [
  "Vendor payment",
  "Monthly recurring charge",
  "Reimbursement claim",
  "Purchase order settlement",
  "Subscription renewal",
  "Service invoice",
  "Advance adjustment",
  "Utility bill",
];

/**
 * The "Login History" tab has no real backend login-audit endpoint behind it
 * yet (the app uses the real backend login/SSO flow — see src/pages/auth/*
 * — but login events aren't persisted anywhere queryable). This used to hold
 * fabricated sample rows; left empty until a real audit endpoint exists,
 * rather than showing made-up login events for real accounts.
 */
export const seedLogins: LoginRecord[] = [];
